<template>
    <div class="image-artifact cr-mb6">
        <cr-loading v-if="loading"/>
        <cr-image v-if="src" v-show="!loading" :src="src" :alt="artifact.name" @load="onLoaded" @error="onLoaded" />
    </div>
</template>

<style scoped>
.image-artifact
{
    display: flex;
    justify-content: center;
}
.image-artifact :deep(img)
{
    max-width: 100%;
    height: auto;
    /* Fits buttons at 1080p without scrolling */
    max-height: 21rem; 
}
</style>

<script setup lang="ts">
import { IChallengeArtifact } from '@cyber-range/cyber-range-api-ctf-challenge-client';
import { useFileStore } from '../../stores/fileStore';
import { ref, watch } from 'vue';

const props = defineProps<{
    artifact: IChallengeArtifact;
}>();

const src = ref<string>('');
const loading = ref<boolean>(true);

function onLoaded()
{
    loading.value = false;
}

watch(() => props.artifact, async (artifact) =>
{
    src.value = '';
    loading.value = true;
    const file = await useFileStore().getOneDownloadUrl(artifact.value);
    src.value = file?.publicUrl || '';
}, { immediate: true });
</script>
